<style lang="less"> 
</style>

<template>
  <el-select v-model="value1" placeholder="请选择" clearable @change="change">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
  export default {
    props: {
      value: {
        required: true,
        default: null
      },
      datadict: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        value1: '',
        options: [] //选项
      }
    },
    watch: {
      value1(val) {
        this.$emit('input', val);
      },
      value(val) {
        this.value1 = val;
      }
    },    
    mounted() {
      this.init();
    },
    methods: {
      //初始化
      init() {
        this.value1 = this.value;
        this.$http.get('/ws/sys/datadict/' + this.datadict + '/v1').then(response => {
          var res = response.body;
          var resMeta = res.meta;
          if(0 == resMeta.code) {
            var datas = res.data;
            for(var i in datas) {
              var data_ = datas[i];
              this.options.push({value: data_.wValue, label: data_.displayName});
            }
          } else {
            this.$Wmsg.error(resMeta.message);
          }
        });         
      },
	  change() {
	  	this.$emit('change', this.value1);
	  }
    }
  }
</script>


// WEBPACK FOOTER //
// index.vue?2c3045b6